import { createSlice } from "@reduxjs/toolkit";
import { getfacebookAdsetList } from "./ThunkActions";
import {  REDUCER_NAME, IFacebookAdsetState } from "./Types";

// Define initial state based on the provided structure
const initialState: IFacebookAdsetState = {
  isLoading: false,
  facebookAdsetList: [],
  errorMessage: null,
};

export const facebookAdsetSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetfacebookAdsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getfacebookAdsetList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getfacebookAdsetList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.facebookAdsetList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getfacebookAdsetList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Ads list";
        state.isLoading = false;
      });
  },
});

export const { resetfacebookAdsState } = facebookAdsetSlice.actions;
export default facebookAdsetSlice.reducer;
